"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggedInIcon = exports.LoggedOutIcon = exports.AccountMenuButton = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_2 = require("@headlessui/react");
const fa_1 = require("react-icons/fa");
function AccountMenuButton(_a) {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (react_1.default.createElement(react_2.Menu.Button, Object.assign({ as: "button", className: (0, classnames_1.default)('mr-3 text-gray-74 transition-colors hover:text-gray hover:cursor-pointer solid-focus-ring', className) }, props),
        react_1.default.createElement("span", { className: "pointer-events-none" }, children)));
}
exports.AccountMenuButton = AccountMenuButton;
const LoggedOutIcon = () => {
    return react_1.default.createElement(fa_1.FaRegUser, { style: { fontSize: '27px' } });
};
exports.LoggedOutIcon = LoggedOutIcon;
const LoggedInIcon = (_a) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (react_1.default.createElement("p", Object.assign({ className: (0, classnames_1.default)('text-sm border-2 border-gray-74 hover:border-gray rounded-full h-7 w-7 flex justify-center items-center', className) }, props), children));
};
exports.LoggedInIcon = LoggedInIcon;
